import { useIntl } from 'react-intl'
import { Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import ActivitiesHeader from './ActiviesHeader/ActivitiesHeader'
import { CardMode } from '@/app/models/card'
import { LuxIconSpinner } from '@lux/wardrobe-lib'
import CalendarActivity from '../CalendarActivities/CalendarActivitiesList/CalendarActivity/CalendarActivity'

const maxChar = 50

const Activities = (props: any) => {
    const { activities, loading, showContent, hideSidebar, openActivity } = props

    const intl = useIntl()

    const activitiesClass = 'home-activities'

    const paginationConfig = {
        clickable: true,
    }

    return (
        <div className={`${activitiesClass}${hideSidebar ? ' hideSidebar' : ''}`}>
            <div
                className={`${activitiesClass}__container ${!showContent ? 'hide-content' : ''} ${
                    showContent && !activities?.length ? 'empty-content' : ''
                }`}>
                <ActivitiesHeader />
                {loading ? (
                    <LuxIconSpinner />
                ) : (
                    <div
                        data-length={activities?.length}
                        className={`${activitiesClass}__content ${
                            !showContent ? `${activitiesClass}__content--hide` : ''
                        }`}>
                        {activities?.length > 0 ? (
                            <div className={`${activitiesClass}__card-container`}>
                                <Swiper
                                    spaceBetween={15}
                                    modules={[Pagination]}
                                    slidesPerView={'auto'}
                                    pagination={paginationConfig}>
                                    {activities.map((activity) => {
                                        let title = activity.title
                                        if (title.length > maxChar)
                                            title = `${title.slice(0, maxChar)}...`
                                        return (
                                            <SwiperSlide key={activity.id}>
                                                <div
                                                    key={activity.id}
                                                    className={`${activitiesClass}__card`}>
                                                    <CalendarActivity
                                                        id={activity.id}
                                                        title={title}
                                                        time={activity.time}
                                                        dueTime={activity.dueTime}
                                                        type={activity.type}
                                                        sourceModule={activity.sourceModule}
                                                        isMostUrgent={activity.isMostUrgent}
                                                        status={activity.status}
                                                        isRead={activity.isRead}
                                                        priority={activity.priority}
                                                        timeZone={activity.timeZone}
                                                        mode={CardMode.SQUARE}
                                                        hasBorderColor={true}
                                                        onClick={() => openActivity(activity)}
                                                    />
                                                </div>
                                            </SwiperSlide>
                                        )
                                    })}
                                </Swiper>
                            </div>
                        ) : (
                            <>
                                {intl.formatMessage({
                                    id: 'home.activities.alert.no_urgent_activities_for_today_congrats',
                                    defaultMessage: 'No urgent activities for today, congrats!',
                                })}
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default Activities
